<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Chat" pageTitle="Chat" />
            <ChatContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ChatContent from '../Chat/ChatContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ChatPage',
    components: {
        MainHeader,
        PageTitle,
        ChatContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>